import Big from 'big.js'

// 百分率として表示する際に保持する小数点以下の桁数。
// ロス率・焼減率で意味のある精度は十分カバーしつつ、
// 浮動小数点の誤差（7.000000000000001 など）は切り落とす。
const PERCENT_DECIMAL_PLACES = 6

/**
 * 割合（0〜1）を百分率（0〜100）へ変換する
 *
 * 単純に 100 を掛けると 0.07 * 100 = 7.000000000000001 のように
 * 浮動小数点の誤差が表示や入力欄にそのまま出てしまうため、
 * big.js で10進数計算したうえで丸める
 */
export const ratioToPercent = (ratio: number): number => {
  if (!Number.isFinite(ratio)) {
    return 0
  }
  return new Big(ratio).times(100).round(PERCENT_DECIMAL_PLACES).toNumber()
}

/**
 * 百分率（0〜100）を割合（0〜1）へ変換する
 *
 * 7.77 / 100 = 0.07769999999999999 のような誤差を避けるため10進数で計算する
 */
export const percentToRatio = (percent: number): number => {
  if (!Number.isFinite(percent)) {
    return 0
  }
  return new Big(percent).div(100).toNumber()
}
